/**
 * This file dynamically compiles the module routes for the client and
 * redirects any route that doesn't match to a 'NotFound'/404 page
 *
 * Below we import all module routes and assign them top-level pathnames as the
 * kebab-case version of their resourceName. For example in resourceRoutes.js.jsx:
 * export { default as userWorkouts } ... would become a top-level Route with the
 * path="/user-workouts" and so on.
 */

// import primary libraries
import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

// import YTRoute from '../global/components/routing/YTRoute.jsx';

// import third-party libraries
import _ from 'lodash';

// import main client and admin routes from the modules
// import * as adminResourceRoutes from './adminResourceRoutes.js';
import * as resourceRoutes from './resourceRoutes.js';

import SuperAdminRouter from '../global/components/routing/SuperAdminRouter.jsx';

// import custom components
import UserLogin from '../resources/user/views/UserLogin.jsx';
import UserRegister from '../resources/user/views/UserRegister.jsx';
import Landing from '../global/components/landing/Landing.jsx';
import YTRoute from '../global/components/routing/YTRoute.jsx';
import GroupLandingTemplateWrapper from '../resources/group/views/GroupLandingTemplateWrapper.jsx';
import GroupSecureLanding from '../resources/group/views/GroupSecureLanding.jsx';
import LegacySingleGroupRedirect from '../resources/group/views/LegacySingleGroupRedirect.jsx';
import DefaultLayout from '../global/components/layouts/DefaultLayout.jsx';
// import GroupPublicLanding from '../resources/group/views/GroupPublicLanding.jsx';
// lazy load the rest to reduce initial bundle size, most users will never need them
const Forbidden = lazy(() => import('../global/components/navigation/Forbidden.jsx'));
const NotFound = lazy(() => import('../global/components/navigation/NotFound.jsx'));
const OrganizationRouter = lazy(() => import('../resources/organization/OrganizationRouter.jsx'));

const routes =
  <Switch>
    <YTRoute exact path="/" component={Landing} breadcrumbs={[{ display: 'Organizations', link: null }]} />
    {/* Moving these special group landing routes to top level since they don't get wrapped in the standard layout */}
    <YTRoute
      breadcrumbs={[{ display: 'Welcome', path: null }]}
      component={GroupSecureLanding}
      // login={true} // no login required for this one
      exact
      path='/groups/secure-landing'
    />
    <YTRoute
      component={GroupLandingTemplateWrapper}
      exact
      path='/groups/landing/:groupSlug/:groupId'
    />
    {/* redirect for legacy single group page */}
    <YTRoute
      exact
      path='/groups/:groupId'
      component={LegacySingleGroupRedirect}
    />
    <Route exact path="/unauthorized" component={Forbidden} />
    {/* moved UserLogin here to the top so it can be loaded without loading the entire user router in the inital bundle */}
    <Route exact path="/user/login" component={UserLogin} />
    <Route exact path="/user/register" component={UserRegister} />
    <Route path="/super">
      <SuperAdminRouter />
    </Route>
    {Object.keys(resourceRoutes).map((resourceName, i) =>
      <Route
        component={resourceRoutes[resourceName]}
        key={`resourceRoute-${i}`}
        path={`/${_.kebabCase(resourceName)}`}
      />
    )}
    <YTRoute path="/:organizationId" component={OrganizationRouter} />
    <Route>
      <DefaultLayout>
        <NotFound />
      </DefaultLayout>
    </Route>
  </Switch>
  ;

export default routes;
